import { render, staticRenderFns } from "./ModalUploadMidia.vue?vue&type=template&id=50603bfc"
import script from "./ModalUploadMidia.vue?vue&type=script&lang=js"
export * from "./ModalUploadMidia.vue?vue&type=script&lang=js"
import style0 from "./ModalUploadMidia.vue?vue&type=style&index=0&id=50603bfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports